import { Component } from '@angular/core'
import { ActiveCartFacade } from '@spartacus/cart/base/root'
import { MbConstants } from '../../../shared/mb-constants'

@Component({
  selector: 'mb-empty-cart',
  templateUrl: './mb-empty-cart.component.html',
  styleUrls: ['./mb-empty-cart.component.scss']
})
export class MbEmptyCartComponent {
  entries$ = this.activeCartService.getEntries()
  constructor (protected activeCartService: ActiveCartFacade) {
  }
  readonly allProductCategoriesUrl = MbConstants.ALL_PRODUCT_CATEGORIES_URL
}
